export default __webpack_public_path__ + "static/media/404.483492e2.jpg";